const main = document.getElementById("main");
const safari = !!navigator.vendor?.match(/apple/i);

function fixSize() {
	let ratio = devicePixelRatio;
	if (safari) ratio /= 2; // safari won't render properly unless everything is neatly lined up
	const w = window.innerWidth * ratio,
		h = window.innerHeight * ratio,
		tileSize = Math.floor(Math.min(w / 12, h / 24)) / ratio;
	main.style = `
		width: ${tileSize * 12}px;
		height: ${tileSize * 24}px;
		left: ${Math.floor(w / 2 - tileSize * 6 * ratio) / ratio}px;
		top: ${Math.floor(h / 2 - tileSize * 12 * ratio) / ratio}px;
		font-size: ${tileSize * 0.5}px;
	`;
	const preview = document.querySelector('#colour-scheme-preview');
	const previewTileSize = Math.floor(tileSize * 2.6) / ratio;
	preview.style = `
		width: ${previewTileSize * 8}px;
		height: ${previewTileSize * 6}px;
		font-size: ${previewTileSize * 0.5}px;
	`;
}

fixSize();
if (safari) setTimeout(fixSize);
window.addEventListener("resize", fixSize);
